import './SortingInput.styles.scss';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import React, { FC, useEffect, useMemo } from 'react';

import { SortDirection } from '../../../model/SortDirection';
import sessionStorageStore from '../../../store/SessionStorageStore';
import { SortingInputProps } from './SortingInput.types';

const SortingInput: FC<SortingInputProps> = ({
  className,
  placeholder = 'Select sorting',
  sessionStorageKey,
  sortingOptionsEnum,
  selectedSortProperty,
  sortDirection,
  onSelectedSortPropertyChanged,
  onSortDirectionChanged,
}) => {
  const sortingOptions = useMemo(() => Object.values(sortingOptionsEnum), []);

  const sortIcon = useMemo(() => {
    if (!sortDirection) {
      return 'pi-sort-alt';
    }
    return sortDirection === SortDirection.ASC
      ? 'pi-sort-amount-up-alt'
      : 'pi-sort-amount-down';
  }, [sortDirection]);

  useEffect(() => {
    const sortingInputData =
      sessionStorageStore.getSortingInputData(sessionStorageKey);
    onSelectedSortPropertyChanged(sortingInputData.sortProperty);
    onSortDirectionChanged(sortingInputData.sortDirection);
  }, []);

  useEffect(() => {
    sessionStorageStore.setSortingInputData(sessionStorageKey, {
      sortDirection,
      sortProperty: selectedSortProperty,
    });
  }, [selectedSortProperty, sortDirection]);

  const onSortingPropertyUpdate = (sortProperty: string): void => {
    if (!selectedSortProperty) {
      onSortDirectionChanged(SortDirection.DESC);
    }
    onSelectedSortPropertyChanged(sortProperty);
  };

  const onClearSorting = (): void => {
    onSelectedSortPropertyChanged(undefined);
    onSortDirectionChanged(undefined);
  };

  return (
    <div
      className={`SortingInput-Component${className ? ` ${className}` : ''}`}
    >
      <div className="p-inputgroup flex-1">
        <Dropdown
          className="sort-dropdown"
          placeholder={placeholder}
          value={selectedSortProperty}
          options={sortingOptions}
          onChange={e => onSortingPropertyUpdate(e.target.value)}
        />
        <Button
          className={`${!selectedSortProperty ? 'sort-not-active' : ''}`}
          disabled={!selectedSortProperty}
          icon={`pi ${sortIcon}`}
          onClick={() =>
            onSortDirectionChanged(
              sortDirection === SortDirection.ASC
                ? SortDirection.DESC
                : SortDirection.ASC,
            )
          }
        />
        <Button
          icon="pi pi-times"
          className="sort-not-active"
          disabled={!selectedSortProperty}
          onClick={onClearSorting}
        />
      </div>
    </div>
  );
};

export default SortingInput;
